import React from 'react';
import { Grid, CircularProgress } from '@mui/material';
//import CategoryCard from './CategoryCard';
import { useEffect, useState } from 'react';
import { fetchNewAndFeaturedLTVs } from '../../common/api/linktivities';
import LinktivityCard from './LinktivityCard';

export default function NewAndFeaturedList(props) {
  const [newLinktivities, setNewLinktivities] = useState([]);
  const [featuredLinktivities, setFeaturedLinktivities] = useState([]);
  const [loading, setLoading] = useState(false);

  const { numItems } = props;

  useEffect(() => {
    setLoading(true);
    fetchNewAndFeaturedLTVs()
      .then((res) => {
        let tempLINKtivities = res.data;
        var tempNewLtvs = [];
        var tempFeaturedLtvs = [];
        let tempNewCount = 0;
        let tempFeaturedCount = 0;

        //semi-randomly sort so that different linktivies show up in the
        //top three on different page loads.
        tempLINKtivities.sort(function (a, b) {
          return 0.5 - Math.random();
        });

        tempLINKtivities.forEach((linktivity) => {
          if (linktivity.new) {
            if (tempNewCount < numItems) {
              tempNewLtvs.push(linktivity);
            }
            tempNewCount++;
          } else if (linktivity.featured) {
            if (tempFeaturedCount < numItems) {
              tempFeaturedLtvs.push(linktivity);
            }
            tempFeaturedCount++;
          }
        });

        setNewLinktivities(tempNewLtvs);
        setFeaturedLinktivities(tempFeaturedLtvs);
      })
      .catch((err) => {
        console.log(err.message);
        setNewLinktivities([]);
        setFeaturedLinktivities([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [numItems]);

  return (
    <>
      {loading ? (
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <CircularProgress color='secondary' />
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          spacing={1}
          direction='row'
          alignItems='center'
          justifyContent='center'
        >
          {newLinktivities.map((linktivity) => (
            <Grid item key={linktivity.linktivity_id}>
              <Grid
                container
                spacing={0}
                direction='row'
                alignItems='center'
                justifyContent='center'
              >
                <Grid item sx={{ margin: '5px' }}>
                  <LinktivityCard
                    id={linktivity.linktivity_id}
                    name={linktivity.linktivity_name}
                    categoryId={99}
                    categoryName={'New & Featured'}
                    thumbnail={linktivity.thumbnail_image_link}
                    featured={linktivity.featured ? linktivity.featured : false}
                    isnew={linktivity.new ? linktivity.new : false}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
          {featuredLinktivities.map((linktivity) => (
            <Grid item key={linktivity.linktivity_id}>
              <Grid
                container
                spacing={0}
                direction='row'
                alignItems='center'
                justifyContent='center'
              >
                <Grid item sx={{ margin: '5px' }}>
                  <LinktivityCard
                    id={linktivity.linktivity_id}
                    name={linktivity.linktivity_name}
                    categoryId={99}
                    categoryName={'New & Featured'}
                    thumbnail={linktivity.thumbnail_image_link}
                    featured={linktivity.featured ? linktivity.featured : false}
                    isnew={linktivity.new ? linktivity.new : false}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
}
